import { createSlice } from '@reduxjs/toolkit';

import S19Image from '../../assets/img/miners/S19.jpg';

const initialState = {
  isLoading: false,
  error: null,
  equipments: [
    {
      id: 'J84F0GFS83F',
      name: 'Antminer S19J Pro',
      image: S19Image,
      connected: '04/05/2024',
      location: {
        apdu: 32,
        socket: 4
      },
      statsDataPrimary: [
        {
          title: 'Total uptime',
          value: 99.97,
          decimal: true,
          suffix: '%',
          prefix: '',
          valueClassName: 'text-warning',
          badgeBg: 'warning'
        },
        {
          title: 'Total Errors',
          value: 1,
          decimal: false,
          suffix: '',
          prefix: '',
          valueClassName: 'text-info',
          badgeBg: 'info'
        },
        {
          title: 'Total Energy Consumed',
          value: 2062.37,
          decimal: true,
          suffix: 'kWh',
          prefix: '',
          valueClassName: '',
          badgeBg: 'success'
        }
      ],
      statsDataSecondary: [
        {
          title: 'Actual Hashrate',
          value: 106,
          decimal: false,
          suffix: '',
          prefix: 'TH/s ',
          valueClassName: 'text-warning'
        },
        {
          title: 'Hashrate 24 Hours',
          value: 104,
          decimal: false,
          suffix: '',
          prefix: 'TH/s ',
          valueClassName: 'text-info'
        },
        {
          title: 'Yesterday Energy consumption',
          value: 3079,
          decimal: false,
          suffix: 'watt',
          prefix: '',
          valueClassName: ''
        }
      ],
      chartData: {
        daysOnline: [36, 37, 37, 38, 38, 38, 39, 40, 41, 41, 42, 43],
        daysOffline: [0, 0, 1, 1, 2, 3, 3, 3, 3, 4, 4, 4]
      },
      minerInfo: {
        customerId: 1,
        customer: 'John Doe',
        serialNumber: '1F45P904NNE4',
        minerID: 'J84F0GFS83F',
        macAddress: '4JA12IIS7',
        actualIPAddress: '172.562.4.2'
      },
      poolInfo: {
        isActive: true,
        connectedPool: 'Luxor',
        poolSubAccount: 45629,
        workerName: '45629.J84F0GFS83F',
        software: 'Bitmain Firmware',
        mode: 'normal'
      }
    }
  ],
  equipmentTypes: [
    {
      id: 10000001,
      kind: 'ASIC',
      name: 'Bitmain Antminer S19J Pro',
      status: 'active',
      driverName: 'string',
      description: 'string',
      hashrate: 104,
      power: 3069
    },
    {
      id: 10000002,
      kind: 'ASIC',
      name: 'Bitmain Antminer S19J',
      status: 'active',
      driverName: 'string',
      description: 'string',
      hashrate: 92,
      power: 2850
    },
    {
      id: 20000001,
      kind: 'ASIC',
      name: 'Bitmain Antminer S21 Pro',
      status: 'inactive',
      driverName: 'string',
      description: 'string',
      hashrate: 210,
      power: 4250
    },
    {
      id: 20000002,
      kind: 'ASIC',
      name: 'Bitmain Antminer S21',
      status: 'inactive',
      driverName: 'string',
      description: 'string',
      hashrate: 200,
      power: 3900
    }
  ],
  asics: [],
  pdus: []
};

const equipmentSlice = createSlice({
  name: 'equipment',
  initialState,
  reducers: {
    // Set loading state for all requests
    requestStart: state => {
      state.isLoading = true;
      state.error = null;
    },
    // Handle failure for all requests
    requestFailure: (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    },

    // Fetch equipment success
    fetchEquipmentSuccess: (state, action) => {
      state.equipments = action.payload;
      state.isLoading = false;
    },

    fetchEquipmentByIdSuccess: (state, action) => {
      state.equipments = state.equipments.map(equipment =>
        equipment.id === action.payload.id
          ? { ...equipment, ...action.payload }
          : equipment
      );
      state.isLoading = false;
    },

    // Fetch equipment types success
    fetchEquipmentTypesSuccess: (state, action) => {
      state.equipmentTypes = [...state.equipmentTypes, action.payload];
      state.isLoading = false;
    },

    // Create equipment success
    createEquipmentTypeSuccess: (state, action) => {
      state.equipmentTypes = [...state.equipmentTypes, action.payload];
      state.isLoading = false;
    }
  }
});

export const {
  requestStart,
  requestFailure,
  fetchEquipmentSuccess,
  fetchEquipmentByIdSuccess,
  fetchEquipmentTypesSuccess,
  createEquipmentSuccess
} = equipmentSlice.actions;

export default equipmentSlice.reducer;
